// src/pages/Loja/ProductsList.jsx corrigido
import React from 'react';
import { useDispatch } from 'react-redux';
import { adicionarItem } from './../../redux/cartReducer';

export default function ProductsList({ produtos }) {
  const dispatch = useDispatch();

  const handleAddToCart = (produto) => {
    dispatch(adicionarItem({ nome: produto.titulo, preco: parseFloat(produto.preco) }));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {produtos.map(produto => (
        <div key={produto.id_produto} className="p-4 border rounded shadow">
          <h3 className="font-bold text-lg">{produto.titulo}</h3>
          <p>{produto.descricao}</p>
          <p className="text-green-600">R$ {parseFloat(produto.preco).toFixed(2)}</p>
          <button
            onClick={() => handleAddToCart(produto)}
            className="mt-2 px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
          >
            Adicionar ao Carrinho
          </button>
        </div>
      ))}
    </div>
  );
}
